export const readOnlyRowsSetup = [
  [
    {colKey: 'name', colSize: '6', header: 'Nome', value: '' },
    {colKey: 'accessId', colSize: '6', header: 'ID de Acesso', value: '' } 
  ],
  [
    {colKey: 'email', colSize: '6', header: 'E-mail', value: '' },
    {colKey: 'roleLabel', colSize: '6', header: 'Função', value: '' } 
  ],
  [
    {colKey: 'instrumentationUrl', colSize: '12', header: 'URL Instrumentação', value: '', type: 'LINK' }
  ]
];